export default function () {
  const widgetName = 'Cards';
  const widgetOpts = CardsOpts;

  let windowSize = $(window).width();
  const breakpoint = 800;
  // Initialize the card widget
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      console.log(data);

      $(`#${widgetName} .card-widget-item`).each(function (x) {
        const $this = $(this);
        $this.find('.image-container').append('<div class="overlay"></div>');
        $this.find('.overlay').append('<div class="overlay-border"></div>');
        $this.find('.buyNowButton').addClass('button');
        $this.find('.moreButton').addClass('button');
        $this.removeAttr('target');
        const widgetData = data.items[x];
        if (widgetData.URL == null) {
          $(this).addClass('voidLink');
          $(this).find('.buttonwrap').remove();
        }
        if (windowSize < 800 && widgetData.URL == null) {
          $(this).removeAttr('href');
        }
      });
    },
    // Set widget options
    link: windowSize < breakpoint ? ['all'] : [],
    maxItemsVisible: 8,
    itemsPerPanel: 8,
    hasImages: true,
    lazyLoadImages: true,
    textOverImage: true,
    imageIsBackground: true,
    showDescription: false,
    buyNowButton: {
      visible: true,
      text: 'BUY NOW',
    },
    moreButton: {
      visible: true,
      text: 'More',
    },
    scriptPath: widgetOpts.scriptPath,
  });
}
